import { useEffect, useRef } from 'react';
import {
  clearDynamicIconStyles,
  getIframeDocument,
  waitForIframeAndPositionIcon,
} from './emailPreviewIframeUtils';

export function useEmailPreviewIconPosition(
  highlightedLinkId: string | null | undefined,
  sanitizedEmailHTML: string,
) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const modalIframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const resetIconForIframe = (iframe: HTMLIFrameElement | null) => {
      const iframeDoc = getIframeDocument(iframe);
      if (iframeDoc) {
        clearDynamicIconStyles(iframeDoc);
      }
    };

    if (!highlightedLinkId) {
      resetIconForIframe(iframeRef.current);
      resetIconForIframe(modalIframeRef.current);
      return;
    }

    waitForIframeAndPositionIcon(iframeRef.current, highlightedLinkId);
    waitForIframeAndPositionIcon(modalIframeRef.current, highlightedLinkId);
  }, [highlightedLinkId, sanitizedEmailHTML]);

  const handleIframeLoad = (isModal: boolean) => {
    const iframe = isModal ? modalIframeRef.current : iframeRef.current;
    waitForIframeAndPositionIcon(iframe, highlightedLinkId);
  };

  return { iframeRef, modalIframeRef, handleIframeLoad };
}
